import {DataObjectId, PermissionRoleKey, User} from 'yougile-model'
import {CompanyPreferencesClient} from '@client/company-preferences-client'
import {getUserAccountName} from '@components/user-name'
import {globals} from '@extensions/globals-base'
import {UserProxy} from '@extensions/proxies/user-proxy'
import {UserAvatarUtils} from '@extensions/user-avatar-utils'
import {
  getDepartments,
  getPosition,
  isBlocked,
  isUserAdmin
} from './dashboard-utils'

export interface UserFields {
  id: DataObjectId
  name: string
  email: string
  position: string
  departments: string
  isBlocked: boolean
  isAdmin: boolean
}

export const extractUserFields = (user: User): UserFields => {
  const email = CompanyPreferencesClient.isAllowedForCurrentUser(
    globals.getCompanyId(),
    'seeEmails'
  )
    ? user?.email ?? ''
    : ''
  return {
    id: user.id,
    name: getUserAccountName({id: user.id}),
    email,
    position: getPosition(user),
    departments: getDepartments(user),
    isBlocked: isBlocked(user.id),
    isAdmin: isUserAdmin(user)
  }
}

export interface PendingRegistration {
  userId: DataObjectId
  timestamp: number
  email: string
  username: string

  inProgress?: boolean
  projectIds?: DataObjectId[]
  role?: PermissionRoleKey
}

export const pendingRegistrationToUserProxy = (
  item: PendingRegistration
): UserProxy => {
  const userId = '' as DataObjectId
  return {
    userId,
    userImage: '',
    userInfo: '',
    userName: item.username,
    userShortName: UserAvatarUtils.avaShortName(item.username, {
      id: userId,
      email: item.email
    }),
    userBackgroundColor: UserAvatarUtils.avaColorByName(
      item.username,
      item.email
    ),
    userStatus: 'online',
    userIsInDoNotDisturbMode: false,
    userIsAdmin: false,
    userEmail: item.email,
    deleted: false
  }
}
